const STORAGE_KEY = 'abrafi-super-dashboard-company-drilldown';
const TARGET_KEY = 'abrafi-super-dashboard-drilldown-target';

/** Mark that the user left super dashboard for a company-scoped page (browser back should restore All Companies). */
export function markSuperDashboardCompanyDrilldown(targetPath?: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, '1');
    if (targetPath) {
      sessionStorage.setItem(TARGET_KEY, targetPath);
    }
  } catch {
    // sessionStorage unavailable — skip
  }
}

export function peekSuperDashboardDrilldownTarget(): string | null {
  try {
    return sessionStorage.getItem(TARGET_KEY);
  } catch {
    return null;
  }
}

export function clearSuperDashboardDrilldownTarget(): void {
  try {
    sessionStorage.removeItem(TARGET_KEY);
  } catch {
    // sessionStorage unavailable — skip
  }
}

export function peekSuperDashboardCompanyDrilldown(): boolean {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function consumeSuperDashboardCompanyDrilldown(): boolean {
  try {
    const marked = sessionStorage.getItem(STORAGE_KEY) === '1';
    if (marked) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
    return marked;
  } catch {
    return false;
  }
}

export function clearSuperDashboardCompanyDrilldown(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // sessionStorage unavailable — skip
  }
}
